// @ts-expect-error module not typed
import PrimaryMessage from '../../primary-message/components/PrimaryMessage';
// @ts-expect-error module not typed
import PrimaryMessageContent from '../../primary-message/components/PrimaryMessageContent';
import { AGENT } from 'conversations-message-history/constants/messageUses';
import FlexRow from '../../shared/components/FlexRow';
import WorkflowGeneratedUserMessageContent from './WorkflowGeneratedUserMessageContent';
import WorkflowGeneratedUserHeaderAttachment from './WorkflowGeneratedUserHeaderAttachment';
import { WorkflowGeneratedUserMessageSource } from './WorkflowGeneratedUserMessageSource';
import { getHeaderAttachment, getQuickRpliesAttachment, getMessageText, isPlainText } from 'conversations-message-history/workflow-generated-user-message/operators/workflowGeneratedUserMessageGetters';
import QuickRepliesAttachment from '../../attachments/QuickRepliesAttachment';
import { getGenericChannelId } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import AutomatedMessageFooter from '../../shared/components/AutomatedMessageFooter';
import AutomatedMessageAvatar from '../../avatar/AutomatedMessageAvatar';
import AutomatedMessageHeader from '../../shared/components/AutomatedMessageHeader';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "WorkflowGeneratedUserMessage__StyledDiv",
  componentId: "exlrwa-0"
})(["display:flex;flex-direction:column;width:100%;"]);
const StyledContentColumn = styled.div.withConfig({
  displayName: "WorkflowGeneratedUserMessage__StyledContentColumn",
  componentId: "exlrwa-1"
})(["display:flex;flex-direction:row;"]);
const WorkflowGeneratedUserMessage = ({
  message,
  fileAttachments,
  positionDescriptors,
  visitorLastReadTimestamp,
  workflowName
}) => {
  const headerAttachment = getHeaderAttachment(message);
  const messageText = getMessageText(message);
  const isContentPlainText = isPlainText(message);
  const quickRepliesAttachment = getQuickRpliesAttachment(message);
  const genericChannelId = getGenericChannelId(message);
  return /*#__PURE__*/_jsxs(PrimaryMessage, {
    "data-test-id": `primary-message-AUTOMATED`,
    use: AGENT,
    children: [/*#__PURE__*/_jsx(FlexRow, {
      children: /*#__PURE__*/_jsx(PrimaryMessageContent, {
        children: /*#__PURE__*/_jsxs(StyledContentColumn, {
          children: [/*#__PURE__*/_jsx(AutomatedMessageAvatar, {}), /*#__PURE__*/_jsxs(StyledDiv, {
            children: [/*#__PURE__*/_jsx(AutomatedMessageHeader, {
              message: message
            }), /*#__PURE__*/_jsx(WorkflowGeneratedUserHeaderAttachment, {
              headerAttachment: headerAttachment,
              fileAttachments: fileAttachments,
              genericChannelId: genericChannelId
            }), /*#__PURE__*/_jsx(WorkflowGeneratedUserMessageContent, {
              messageText: messageText,
              isPlainText: isContentPlainText
            }), quickRepliesAttachment ? /*#__PURE__*/_jsx(QuickRepliesAttachment, {
              quickRepliesAttachment: quickRepliesAttachment
            }) : null, /*#__PURE__*/_jsx(WorkflowGeneratedUserMessageSource, {
              workflowName: workflowName,
              flowId: message.flowId
            })]
          })]
        })
      })
    }), /*#__PURE__*/_jsx(AutomatedMessageFooter, {
      status: message.status,
      timestamp: message.timestamp,
      positionDescriptors: positionDescriptors,
      visitorLastReadTimestamp: visitorLastReadTimestamp
    })]
  });
};
WorkflowGeneratedUserMessage.displayName = 'WorkflowGeneratedUserMessage';
export default WorkflowGeneratedUserMessage;